var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("edit-extra-fields")))]),
      _c(
        "w-card-content",
        [
          _c("app-extra-fields-edit", {
            attrs: {
              value: _vm.value.ExtraFields,
              "name-settings": _vm.extraFieldsNameSettings,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }